import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import { CgClose } from "react-icons/cg";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { useAddIncome, useUpdateIncome } from "../../hooks/useAccounting";
import { useQueryClient } from "react-query";

const AddIncomeDialog = ({ toggleHideModal, show, update }) => {
  const [form, setForm] = useState({
    NameRevenues: "",
    DefaultPriceRevenues: "",
    DescriptionRevenues: "",
    GroupingRevenues: "",
  });

  const queryClient = useQueryClient();

  const initialState = [
    {
      id: "1",
      label: "کلیه درآمد ها",
      value: "کلیه درآمد ها",
    },
    {
      id: "2",
      label: "درآمد های عملیاتی",
      value: "درآمد های عملیاتی",
    },
    {
      id: "3",
      label: "درآمد های غیرعملیاتی",
      value: "درآمد های غیرعملیاتی",
    },
    {
      id: "4",
      label: "درآمد های حقوق و دست مزد",
      value: "درآمد های حقوق و دست مزد",
    },
  ];

  //   react query add new my wite
  const { mutateAsync: addIncome } = useAddIncome();
  // react query update income
  const { mutateAsync: updateIncome } = useUpdateIncome();

  const handleSubmit = async () => {
    if (update?.NameRevenues) {
      await updateIncome(form);
      queryClient.invalidateQueries("income-list");
    } else {
      await addIncome(form);
      queryClient.invalidateQueries("income-list");
    }
    toggleHideModal();
  };

  useEffect(() => {
    if (update) {
      setForm(update);
    }
  }, [update]);

  return (
    <BootstrapModal
      modaltitle="درج هزینه"
      handleClose={toggleHideModal}
      show={show}
      size="lg"
      closebutton={
        <Button
          style={{ width: "40px", border: "none" }}
          onclick={toggleHideModal}
        >
          <CgClose />
        </Button>
      }
    >
      <InputField1
        type="text"
        name="NameRevenues"
        label="نام درآمد"
        onChange={(event) =>
          setForm({ ...form, NameRevenues: event.target.value })
        }
        value={form.NameRevenues}
      />
      <InputField1
        type="number"
        name="DefaultPriceRevenues"
        label="مبلغ پیش فرض"
        onChange={(event) =>
          setForm({ ...form, DefaultPriceRevenues: event.target.value })
        }
        value={form.DefaultPriceRevenues}
      />
      <InputField1
        type="text"
        name="DescriptionRevenues"
        label="شرح درآمد"
        onChange={(event) =>
          setForm({ ...form, DescriptionRevenues: event.target.value })
        }
        value={form.DescriptionRevenues}
      />

      <SimpleSelect1
        label="درآمد دسته بندی"
        res={initialState}
        onChange={(event) =>
          setForm({ ...form, GroupingRevenues: event.value })
        }
        placeholder={update?.GroupingRevenues}
      />
      <Button
        small="100px"
        size="14px"
        bgColor="#0D6EFD"
        color="#fff"
        onclick={handleSubmit}
      >
        تایید
      </Button>
    </BootstrapModal>
  );
};
export default AddIncomeDialog;
